<nav class="nav-vertical__nav">
    <a class="nav-vertical__link" [routerLink]="link.url" [routerLinkActive]="'-active'" *ngFor="let link of links.data">
        <mlp-ng-icon name="arrow-right-1" size="small"></mlp-ng-icon>
        <strong>{{ link.name }}</strong>
    </a>
</nav>